<script setup lang="ts">
import { computed } from 'vue';
import { mapStatusToTag, type TransactionTableRow } from '@peanuds/shared';
import { useTranslation } from 'i18next-vue';

const { row } = defineProps<{ row: TransactionTableRow }>();
const { t } = useTranslation();

const statusInfo = computed(() => mapStatusToTag(row));
</script>

<template>
  <Tag class="cell-status" :severity="statusInfo.severity" :value="t(statusInfo.value)" />
</template>

<style scoped lang="scss">
.cell-status {
  border-radius: $radius-xl;
  font-weight: $font-semibold;

  :deep(.p-tag-label) {
    font-size: 0.75rem;
  }
}
</style>
